import { AxiosResponse } from 'axios';
import { apiGet } from './utils/apiUtils';

const API_BASE_URL: string = process.env.REACT_APP_API_TRANSLATIONS || '';

export const getTranslations = async (
  lang: string,
): Promise<AxiosResponse<Record<string, string>[]>> =>
  apiGet(`${API_BASE_URL}?lang=${lang}`);
